<template>
  <div id="app" class="image-container set-full-height">
    <router-view />
     <help-modal />
  </div>
</template>

<script>
import HelpModal from "@/components/ui/HelpModal.vue";
import mixin from "@/components/shared/mixinUtility";
export default {
  components:{
    "help-modal":HelpModal
  },
  mixins: [mixin],
  created(){
    this.$store.dispatch("setCountries");
    
    this.$store.dispatch("setCurrencies");
    this.$store.dispatch("setRfts");
    this.initDatadog();
  }
}
</script>